import { supabase } from '@/integrations/supabase/client';
import { membershipService } from './membership';
import type { Membership } from '@/contracts/membership';

export interface UserAuthData {
  roles: Array<{ role: string }>;
  profile: {
    is_pro_member: boolean;
    is_vendor: boolean;
    avatar_url: string | null;
  } | null;
  membership: Membership | null;
}

/**
 * Auth data facade - fetches all user data in PARALLEL
 * Implements playbook pattern: thin UI, fat services, cacheable
 */
export async function getUserAuthData(userId: string): Promise<UserAuthData> {
  const [rolesRes, profileRes, membership] = await Promise.all([
    supabase.from('user_roles').select('role').eq('user_id', userId),
    supabase.from('profiles').select('is_pro_member, is_vendor, avatar_url').eq('user_id', userId).single(),
    membershipService.getMembership(userId),
  ]);
  
  return {
    roles: rolesRes.data || [],
    profile: profileRes.data,
    membership,
  };
}
